import { format } from "date-fns";
import type { ConnectProto } from "@racoon/api";
import { fromTimestamp } from "@racoon/lib";

/**
 * The jobs table showing just this job, highlighted: it searches by id, and its date
 * range must still cover the job or the table filters it out.
 */
export function jobsPageUrl(companyId: number | string, job: ConnectProto.Job): string {
  // The table windows on tw_start_at; a job without one can only be found by fact_end_at.
  const factEnd = fromTimestamp(job.factEndAt);
  const byFactEnd = !fromTimestamp(job.twStartAt) && factEnd != null;
  const dates = byFactEnd
    ? [factEnd]
    : [job.twStartAt, job.twEndAt, job.planStartAt, job.planEndAt]
        .map(fromTimestamp)
        .filter((d): d is Date => d != null);
  const range = dates.length ? dates : [new Date()];
  const ymd = (d: Date) => format(d, "yyyy-MM-dd");
  const params = new URLSearchParams({
    highlightOrder: String(job.id),
    search: String(job.id),
    start_date: ymd(new Date(Math.min(...range.map(Number)))),
    end_date: ymd(new Date(Math.max(...range.map(Number)))),
    ...(byFactEnd && { dateField: "fact_end_at" }),
  });
  return `/${companyId}/orders?${params}`;
}
